import { Router } from '@angular/router';
import { TweenMax, Quint, Sine } from 'gsap';
import { AutenticationEventType } from './../autentication.event.type';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AuthMessage } from '../models/auth-message';
import { AutenticationService } from '../autentication.service';
import { EventTypes } from '../../shared/EventTypes';
import { Auth } from '../Auth';
import { User } from '../models/user';

@Component({
	selector: 'app-auth-message',
	templateUrl: './auth-message.component.html',
	styleUrls: ['./auth-message.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AuthMessageComponent implements OnInit, OnDestroy {

	authMessageData: AuthMessage = new AuthMessage();
	active: boolean;
	view = '[data-component="auth-message"]';
	loading: boolean;
	withPreload: boolean;
	blockSend = false;
	sending;

	constructor(private authService: AutenticationService, private router: Router) { }

	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.LOGIN.AUTH_MESSAGE, (data: AuthMessage) => {

			this.authMessageData = data;
			this.active = true;
			this.withPreload = data.withPreload;

			if (data.withPreload) {
				AppEventDispatcher.listen(AutenticationEventType.AUTH_MESSAGE.LOAD_COMPLETE, (error: any) => {

					this.loading = false;
					this.blockSend = false;

					if (!error) {
						this.hide();
					}

				});
			}

			const interval = setInterval(() => {
				if ($(this.view).length > 0) {
					this.show(data);
					clearInterval(interval);
				}
			}, 10);

		});
	}

	dispatchEvent() {
		if (!this.blockSend) {
			if (this.authMessageData.delayToDispatchEvent > 0) {
				TweenMax.delayedCall(this.authMessageData.delayToDispatchEvent, () => {
					AppEventDispatcher.dispatch(this.authMessageData.eventToDispatch, this.authMessageData.eventData);
				});
			} else {
				if (this.authMessageData.eventToDispatch) {
					AppEventDispatcher.dispatch(this.authMessageData.eventToDispatch, this.authMessageData.eventData);
				} else {
					this.router.navigate(['']);
				}
			}
		}

		if (this.withPreload) {
			this.loading = true;
			this.blockSend = true;
		} else {
			this.hide();
		}
	}

	show(data) {
		TweenMax.to('[data-component="login"]', .8, { height: 450, ease: Sine.easeOut});
		TweenMax.to(this.view, .8, {delay: data.delay, left: 0, ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to(this.view, .8, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.CREATE_PASS_SUCCESS);
		AppEventDispatcher.removeListener(AutenticationEventType.AUTH_MESSAGE.LOAD_COMPLETE);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/auth-message/auth-message.component.ts